module.exports = __webpack_public_path__ + "img/avatar.44027896.jpg";